function is_mobile() {
  if (/Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|BlackBerry/i.test(navigator.userAgent)) {
    return true;
  }

  return false;
}


function removeQueryParam(url, param) {
  const [base, query] = url.split('?');
  if (!query) return url;

  const params = new URLSearchParams(query);
  params.delete(param);

  const newQuery = params.toString();
  return newQuery ? `${base}?${newQuery}` : base;
}


function parseComicVariant(issueStr) {
  const str = issueStr.trim();

  // Explicit VAR format like "#105 VAR A (2016)"
  const varMatch = str.match(/\bVAR\s+([^()]+?)(?=\s*\(|$)/i);
  if (varMatch) return varMatch[1].trim().toUpperCase();

  // Explicit CVR format like "#105 CVR A (2016)"
  const cvrMatch = str.match(/\bCVR\s+([^()]+?)(?=\s*\(|$)/i);
  if (cvrMatch) return cvrMatch[1].trim().toUpperCase();

  // Fractional variant like "#49/850 J"
  const fractionMatch = str.match(/\/\d+\s+([A-Z]+)\b/);
  if (fractionMatch) return fractionMatch[1].toUpperCase();

  // Hyphenated variant like "#78.BEY-A"
  const hyphenMatch = str.match(/[-]([A-Z]+)\b/);
  if (hyphenMatch) return hyphenMatch[1].toUpperCase();

  // Space-separated variant like "#50.LR A"
  const spaceMatch = str.match(/\s([A-Z]+)\b/);
  if (spaceMatch) return spaceMatch[1].toUpperCase();

  // Suffix variant like "#1A"
  const suffixMatch = str.match(/#\d+([A-Z]+)\b/);
  if (suffixMatch) return suffixMatch[1].toUpperCase();

  // Prefix variant like "AN1"
  const prefixMatch = str.match(/^([A-Z]+)\d+\b/);
  if (prefixMatch) return "A"; // Treat as default A cover

  // Embedded code like "#3CON"
  const embeddedMatch = str.match(/#\d+([A-Z]+)\b/);
  if (embeddedMatch) return embeddedMatch[1].toUpperCase();

  // Default to A if no variant found
  return "A";
}


function isComicACover(issueStr) {
  const variant = parseVariant(issueStr);
  return variant === "A";
}


function flatten_collection_flags() {
  if (!window.collectionFlags) {
    console.error('window.collectionFlags not available');
    return {};
  }
  
  const flattened = {};
  const integerFlags = {};
  
  // First pass: collect all true values
  for (const collection in window.collectionFlags) {
    const flags = window.collectionFlags[collection];
    for (const flag in flags) {
      if (flags[flag] === true) {
        flattened[flag] = true;
      } else if (Number.isInteger(flags[flag])) {
        integerFlags[flag] = flags[flag];
      }
    }
  }
  
  // Second pass: override with false values (false takes priority over true)
  for (const collection in window.collectionFlags) {
    const flags = window.collectionFlags[collection];
    for (const flag in flags) {
      if (flags[flag] === false) {
        flattened[flag] = false;
      }
    }
  }

  for (const flag in integerFlags) {
    if (flattened[flag] === undefined) {
      flattened[flag] = integerFlags[flag];
    }
  }
  
  // Store the flattened flags
  window.collectionFlags = flattened;
}